export function applyParamPatch(
  prev: URLSearchParams,
  updates: Record<string, string | undefined>
): URLSearchParams {
  const next = new URLSearchParams(prev);
  Object.entries(updates).forEach(([key, value]) => {
    if (value) next.set(key, value);
    else next.delete(key);
  });
  return next;
}

export function readLiveSearchParams(
  loc: { hash: string; search: string } = window.location
): URLSearchParams {
  const queryIndex = loc.hash.indexOf("?");
  return new URLSearchParams(
    queryIndex === -1 ? loc.search : loc.hash.slice(queryIndex + 1)
  );
}
